import React from 'react';
import { TUseTipsByDefault } from 'types';
import { TipsFieldNew } from './components/TipsFieldNew';

interface IProps {
	setTips0: (value: Nullable<number>) => void;
	setTips1: (value: Nullable<number>) => void;
	setTips2: (value: Nullable<number>) => void;
	setTips3: (value: Nullable<number>) => void;
	setDefaultTips: (value: TUseTipsByDefault) => void;
	defaultTips: TUseTipsByDefault;
}

export const TipsBlockNew: React.FC<IProps> = ({
	setTips0,
	setTips1,
	setTips2,
	setTips3,
	setDefaultTips,
	defaultTips,
}) => (
	<div className="flex flex-col gap-4">
		<div className="flex items-start gap-4">
			<TipsFieldNew setTips={setTips0} setDefaultTips={setDefaultTips} defaultTips={defaultTips} tipsNumber="0" />
			<TipsFieldNew setTips={setTips1} setDefaultTips={setDefaultTips} defaultTips={defaultTips} tipsNumber="1" />
		</div>
		<div className="flex items-start gap-4">
			<TipsFieldNew setTips={setTips2} setDefaultTips={setDefaultTips} defaultTips={defaultTips} tipsNumber="2" />
			<TipsFieldNew setTips={setTips3} setDefaultTips={setDefaultTips} defaultTips={defaultTips} tipsNumber="3" />
		</div>
	</div>
);
